import xappmediaProducts from "generated/products-xappmedia";
import xappaiProducts from "generated/products-xapp-ai";

export interface Product {
    id: string;
    name: string;
    active: boolean;
    metadata?: {
        chat?: string;
        gbm?: string;
        search?: string;
        partner?: "lacrm" | "jobber" | string,
        ["live-chat"]?: string;
        sku?: string;
    }
}

export function getProducts(partner?: string): Product[] {

    // Pull in the correct set of products depending on environment

    const products: Product[] = [];

    if (__ENV__ === "development") {
        // push both sets of products
        products.push(...xappmediaProducts);
        products.push(...xappaiProducts);
    } else {
        if (__ACCOUNT__ === "stentor") {
            // just for testing products.push(...xappaiProducts);
            products.push(...xappmediaProducts)
        } else if (__ACCOUNT__ === "studio") {
            products.push(...xappaiProducts);
        }
    }

    if (partner) {
        const filtered = products.filter((product) => {
            return product?.metadata?.partner === partner;
        });

        return filtered;
    }

    return products;
}

export function supportsSearch(productId: string): boolean {
    const product = getProducts().find((product) => product.id === productId);

    if (!product) {
        return false;
    }

    return product.metadata?.search === "true";
}

export function supportsGBM(productId: string): boolean {
    const product = getProducts().find((product) => product.id === productId);

    if (!product) {
        return false;
    }

    return product.metadata?.gbm === "true";
}

export function supportsLiveChat(productId: string): boolean {
    const product = getProducts().find((product) => product.id === productId);

    if (!product) {
        return false;
    }

    return product.metadata?.["live-chat"] === "true";
}